import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode.ts';
import { PageMode } from '@confluence/page-utils/entry-points/enums.ts';

/**
 * Coarse *context* eligibility for the OnCriteria Content Reviewer path: Rovo is available, the user
 * has not already seen the nudge, and the page is edit or live (view can be added here later).
 *
 * This is the base gate only — the actual criteria matching (content-state transition, word count)
 * lives in `useContentReviewerNudge`. It is also consumed independently to decide whether to fetch
 * the content fragment. The OnPublish event trigger does NOT go through this gate: it fires via the
 * `overrideSignal` on `useContentReviewerNudge` so it can surface on the view page, which this gate
 * intentionally excludes.
 */
export const useContentReviewerNudgeOnCriteriaBaseEligibility = (): boolean => {
	const { isRovoLLMEnabled, isAIEarlyAccessEnabled, isAdminHubAIEnabled } = useSessionData();
	const pageMode = useGetPageMode();
	const hasUserSeenNudge = confluenceLocalStorageInstance.getItemAsBoolean(
		keys.AUTOMATION_DISCOVER_CONTENT_REVIEWER,
	);

	return (
		!hasUserSeenNudge &&
		isRovoLLMEnabled &&
		isAIEarlyAccessEnabled &&
		isAdminHubAIEnabled &&
		(pageMode === PageMode.EDIT || pageMode === PageMode.LIVE)
	);
};
